import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import {Editor} from '../editor-components';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import Spinner from '../spinner/spinner';
import StageEditor from '../stage-editor/stage-editor';
import ScreenEmulator from '../screen-emulator/screen-emulator';

/** @class LobbyEditor
  * A component for editing a virtual expo's lobby.
  */
export default class LobbyEditor extends ReactFireComponent {
  /** @constructor
    * Constructs a new instace of LobbyEditor
    */
  constructor(props) {
    super(props);
    const expoID = props.match.params.expoID;
    const showID = props.match.params.showID;
    const hallID = props.match.params.hallID;
    this.state = {
      expoID: expoID,
      showID: showID,
      hallID: hallID
    }
    this.dataURL = props.match.url;
  }
  /** @method componentWillMount
    * Connects the component to firebase
    */
  componentWillMount() {
    this.bindAsObject(this.dataURL + '/stage', 'stage')
  }
  /** @method componentWillUnmount
    * Removes the component's connection to firebase
    */
  componentWillUnmount() {
    this.unbind('stage')
  }
  /** @method render
    * Renders the component.
    */
  render() {
    if(!this.state.stage) return <Spinner/>
    return (
      <Editor>
        <Tabs>
          <TabList>
            <Tab>Stage</Tab>
            <Tab>Preview</Tab>
          </TabList>
          <TabPanel>
            <StageEditor {...this.state.stage} dataURL={`${this.dataURL}/stage`} />
          </TabPanel>
          <TabPanel>
            <ScreenEmulator src={`/preview/${this.state.expoID}/${this.state.showID}/#/lobby/stage`} />
          </TabPanel>
        </Tabs>
      </Editor>
    );
  }
}



// WEBPACK FOOTER //
// ./src/lobby-editor/lobby-editor.js